import type { AddBalancePostingsCommandData } from '@festina/life-general-types/life'
import { typeUtils } from '@festina-life/core'
import { FormikDateInput, FormikForm } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import type { CommandDataFormProps } from '../../commandActions/CommandDataFormAndSimulation'
import { BalancePostingSpecsTable } from './BalancePostingSpecsTable'
import { FractionBalancePostingSpecsTable } from './FractionBalancePostingSpecsTable'

const validateKey = typeUtils.createValidator<AddBalancePostingsCommandData>()

export function AddBalancePostingsForm({
  onSubmit,
  ...props
}: CommandDataFormProps<AddBalancePostingsCommandData>) {
  const translate = useTranslate()

  const handleSubmit = async (values: AddBalancePostingsCommandData) => {
    await onSubmit({
      ...values,
      balancePostingSpecs: values.balancePostingSpecs?.length
        ? values.balancePostingSpecs
        : undefined,
      fractionBalancePostingSpecs: values.fractionBalancePostingSpecs?.length
        ? values.fractionBalancePostingSpecs
        : undefined,
    })
  }

  return (
    <FormikForm
      initialValues={
        {
          _type: 'AddBalancePostingsCommandData',
        } satisfies AddBalancePostingsCommandData
      }
      onSubmit={handleSubmit}
      {...props}
    >
      <FormikDateInput
        name={validateKey('changeDate')}
        label={translate('action.addBalancePosting.field.changeDate')}
      />
      <BalancePostingSpecsTable />
      <FractionBalancePostingSpecsTable />
    </FormikForm>
  )
}
